export default __webpack_public_path__ + "static/media/edit_calendar.c2bec5c3.gif";